<div *ngIf="descriptionBadges?.length" class="product-description-badges-wrapper">
  <div
    *ngFor="let badge of descriptionBadges"
    [reactComponent]="BadgeComponent$"
    [props]="{ label: badge.label, imageUrl: badge.imageUrl }"
  ></div>
</div>
